//
// Functions etc. that are concerned with presentation
//
import { ChartDocument } from 'src/components/pages/patientShow/documents/types';

export function getDisplayName(doc: ChartDocument) {
  return doc.title || doc.file?.filename;
}
